/**
 * @file use-loading.js
 * @description Hook para usar o contexto de loading (CRA)
 */

import { useContext } from "react"
import { LoadingContext } from "../contexts/loading-context.js"

/**
 * Hook para usar o contexto de loading
 * @returns {Object} Objeto com o contexto de loading
 */
export function useLoading() {
  const context = useContext(LoadingContext)
  if (context === undefined) {
    throw new Error("useLoading must be used within a LoadingProvider")
  }
  return context
}
